import * as $ from 'jquery';
import {domReady} from '../Utility/DomReady';
import {initFancyBox} from '../DriveSelection/FancyBoxUtility';
import {initializeLoginState} from '../LoginStatus/Functions/LoginStateUtility';
import {initTooltips} from '../Controllers/TooltipController';

domReady(() => {
  initFancyBox();
  initializeLoginState();
  initTooltips();

  if (document.querySelector('.js-fdcVueForm')) {
    import(/* webpackChunkName: "DriveSelectionMainVueForm" */ '../DriveSelection/DriveSelectionMainVueForm').then(module => {
      new module.DriveSelectionMainVueForm();
    });
  }

  if (document.querySelector('.js-fdcList')) {
    import(/* webpackChunkName: "DriveSelectionList" */ '../DriveSelection/DriveSelectionList').then(module => {
      new module.DriveSelectionList();
    });
  }

  if (document.querySelector('.js-fdcDetail')) {
    import(/* webpackChunkName: "DriveSelectionDetail" */ '../DriveSelection/DriveSelectionDetail').then(module => {
      new module.DriveSelectionDetail();
    });
  }
});
